import {defineStore} from 'pinia'

export const usePaymentMethodStore = defineStore({
    id: 'payment_method',
    state: () => ({
        payment_methods: [],
        payment_method: null,
        itemLength: 0,
        loading: false,
        serverOptions: {
            page: 0,
            rows: 10,
            sortBy: 'position',
            sortType: 'asc',
        }
    }),
    getters: {},
    actions: {
        index() {
            this.loading = true
            const params = {
                page: this.serverOptions.page + 1,
                size: this.serverOptions.rows
            }
            return this.apiClient.get('/payments/methods', {params}).then(({data}) => {
                this.payment_methods = data.payment_methods
                this.itemLength = data.payment_methods.length
                this.loading = false
            }).catch((error) => {
                this.loading = false
                throw error
            })
        },
        show(id) {
            return this.apiClient.get(`/payments/methods/${id}`).then(({data}) => {
                this.payment_method = data.payment_method
                return {data}
            })
        },
        create(payment_method) {
            return this.apiClient.post('/payments/methods', {payment_method})
        },
        update(id, payment_method, method = 'put') {
            return this.apiClient[method](`/payments/methods/${id}`, {payment_method})
        },
    },
})
